import { render, staticRenderFns } from "./MultipleBarCharts.vue?vue&type=template&id=3dd4ed27&scoped=true"
import script from "./MultipleBarCharts.vue?vue&type=script&lang=js"
export * from "./MultipleBarCharts.vue?vue&type=script&lang=js"
import style0 from "./MultipleBarCharts.vue?vue&type=style&index=0&id=3dd4ed27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4ed27",
  null
  
)

export default component.exports